import React, { Component, useEffect, useState } from "react";
import "./CapacitacionesModule.css";
import { PostData } from "../../../Services/PostData";
import Moment from "moment";

//ADL Sample Code to Retrieve API Reference

export default function CapacitacionesModule(props) {
  const [capCalled, setCapCalled] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [capacitaciones, setCapacitaciones] = useState({});

  console.log(window.API);

  window.API.on("LMSInitialize", function () {
    window.API.apiLogLevel = 1;
    window.API.cmi.core._student_id = localStorage.getItem("usrToken");
    window.API.cmi.exit = "normal";
    console.log("iniciado");
  });

  window.API.on("LMSFinish", function () {
    console.log("finalizado");
    console.log(window.API.cmi);
    const funcion = {};
    funcion.Function = "postCapacitacionesResult";
    funcion.RequestType = "Post";
    funcion.Event = "CAPACITACION";
    funcion.usrToken = localStorage.getItem("usrToken");
    PostData("POST", funcion).then((result) => {
      setCapacitaciones(result);
      setIsLoading(false);
    }, []);
    window.navigation.reload();
    window.API.reset();
  });

  useEffect(() => {
    var apiHandle = null;

    function getAPIHandle() {
      if (apiHandle == null) {
        apiHandle = getAPI();
      }

      return apiHandle;
    }

    function getAPI() {
      var theAPI = findAPI(window);

      if (
        theAPI == null &&
        window.opener != null &&
        typeof window.opener != "undefined"
      ) {
        theAPI = findAPI(window.opener);
      }

      if (theAPI == null) {
        alert("Unable to find an API adapter");
      }

      return theAPI;
    }

    function findAPI(win) {
      var findAPITries = 0;

      while (win.API == null && win.parent != null && win.parent != win) {
        findAPITries++;

        // Note: 7 is an arbitrary number, but should be more than sufficient

        if (findAPITries > 7) {
          alert("Error finding API -- too deeply nested.");

          return null;
        }

        win = win.parent;
      }

      return win.API;
    }

    //Function to set a value in the LMS

    function SetValue(name, value) {
      var api = getAPIHandle();

      return api.LMSSetValue(name, value);
    }

    //Function to retrieve a value from the lms

    function Getvalue(name) {
      var api = getAPIHandle();

      return api.LMSGetValue(name);
    }

    //The following 4 lines handle our actions for this example

    // get the API, Initialize the LMS, retrieve a value, set a value

    var api = getAPIHandle();

    window.API.reset();

    if (!props.start) {
      var refreshIntervalId = setInterval(function () {
        console.log(window.API.cmi.core.lesson_status);
        if (window.API.cmi.core.lesson_status == "passed") {
          console.log("finished");
          clearInterval(refreshIntervalId);
          window.API.LMSFinish();
        } else {
          console.log("ongonig");
        }
      }, 5000);
    }

    setCapCalled(props.cap.React);
  }, []);

  if (props.start) {
    return (
      <>
        <div className="">
          <h2>Estado de Capacitaciones</h2>
          Este es el estado general de tus capacitaciones. Tene en cuenta que
          "Desaprobado o no realizado" puede significar que nunca hiciste la
          capacitacion, se venció o la desaprobaste. Para mas informacion
          consulta con tu supervisor.
          <br />
          <br />
        </div>
        {Object.keys(props.cap).map((key) => {
          return (
            <div key={key}>
              <h4>{props.cap[key].nombre}</h4>
              <div className="flx">
                <div key={`status` + props.cap[key].ID}>Estado:</div>
                <div>
                  {props.cap[key].status != undefined
                    ? "Aprobado"
                    : "Desaprobado o no realizado"}
                </div>
              </div>
              <div className="flx">
                <div key={props.cap[key].ID}>Fecha de Realizacion:</div>
                <div>
                  {props.cap[key].fecha != undefined
                    ? Moment(props.cap[key].fecha).format("DD-MM-YYYY")
                    : "-"}
                </div>
              </div>
              <div className="flx">
                <div key={props.cap[key].ID}>Fecha de Vencimiento:</div>
                <div>
                  {props.cap[key].venc != undefined
                    ? Moment(props.cap[key].venc).format("DD-MM-YYYY")
                    : "-"}
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  } else {
    return (
      <>
        <iframe width={"100%"} height={"100%"} src={capCalled}></iframe>
      </>
    );
  }
}
